import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({
  baseURL: API,
  withCredentials: true,
});

client.interceptors.request.use((config) => {
  const token = localStorage.getItem("td_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Binary subscription gate: the backend returns 402 {detail:"subscription_required"}
// for any app endpoint when the user (or their household owner) has no active
// subscription. Route them to the value/activation screen instead of failing
// silently. Never bounce while already on the activation/billing screens (avoids
// a redirect loop right after checkout returns to /perfil).
const GATE_EXEMPT_PATHS = ["/activar", "/perfil"];

client.interceptors.response.use(
  (r) => r,
  (error) => {
    const status = error?.response?.status;
    const detail = error?.response?.data?.detail;
    if (status === 402 && detail === "subscription_required") {
      const path = window.location.pathname;
      if (!GATE_EXEMPT_PATHS.includes(path)) {
        const plan = new URLSearchParams(window.location.search).get("plan");
        window.location.assign(`/activar${plan ? `?plan=${encodeURIComponent(plan)}` : ""}`);
      }
    }
    return Promise.reject(error);
  }
);

export default client;
